import { render, staticRenderFns } from "./DashView.vue?vue&type=template&id=4898dba0&scoped=true&"
import script from "./DashView.vue?vue&type=script&lang=js&"
export * from "./DashView.vue?vue&type=script&lang=js&"
import style0 from "./DashView.vue?vue&type=style&index=0&id=4898dba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898dba0",
  null
  
)

export default component.exports